<template>
  <div id="app">
    <div class="footer w-100">
      <div class="footer_txt row">
        <div class="footer1 col-lg-4 col-md-12 col-sm-12">
          <img class="footer-logo" src="../../../static/img/header_logo.png" alt />
          <span class="footer1_txt1">Ningbo Naida Filter Tech Co.,Ltd. is a famous manufacturer of water treatment systems in China.We are producing and supplying all domestic&commercial RO unit,UItra pure water system.</span>
        </div>
        <div class="footer2 col-lg-4 col-md-12 col-sm-12">
          <span class="footer2_txt">Quick Navigation</span>
          <div class="footer2_txt_ul">
            <ul class="footer2_ul">
              <li class="">
                <span><router-link to="/about"><img src="../../../static/img/li.png" alt="">About us</router-link></span>
              </li>
              <li class="">
                <span><router-link to="/download"><img src="../../../static/img/li.png" alt="">Download</router-link></span>
              </li>
              <li class="">
                <span><router-link to="/about"><img src="../../../static/img/li.png" alt="">News</router-link></span>
              </li>
            </ul>
            <ul class="footer2_ul">
              <li class="">
                <span><router-link :to="{path:'/product',query:{id:51}}"><img src="../../../static/img/li.png" alt="">Product</router-link></span>
              </li>
              <li class="">
                <span><router-link to="/support"><img src="../../../static/img/li.png" alt="">Support</router-link></span>
              </li>
              <li class="">
                <span><router-link to="/contact"><img src="../../../static/img/li.png" alt="">Contact us</router-link></span>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer3 col-lg-4 col-md-12 col-sm-12 w-100">
            <span class="footer3_header w-100">Contact Us</span>
            <div class="w-100">
                <img class="img1" src="../../img/地址.png" alt=""><span class="">No.28,Xingbin Road,Sino-Italy Ningbo Ecological Park,Yuyao,Zhejiang,China</span>
            </div>
            <div class="w-100">
                <img class="img2" src="../../img/手机.png" alt=""><span class="">TEL: 0086 574 62096133</span>
            </div>
            <div class="w-100">
                <img class="img3" src="../../img/邮箱.png" alt=""><span class="">E-mail: <div>sales@waternaida.com</div><div>service@waternaida.com</div></span>
            </div>
            <div><img src="../../img/app.png" alt=""></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#app {
  width: 100%;
}
.row {
  padding: 0;
  margin: 0;
}
@media screen and (max-width: 1900px) {
  .footer2_ul {
    width: 30%;
    margin: 0;
    padding: 0;
    margin-top: 20px;
  }
  .footer2 {
    /*margin-top: 20px;*/
  }
}
@media screen and (min-width: 1901px) {
  .footer2_ul {
    width: 25%;
    margin: 0;
    padding: 0;
    margin-top: 20px;
  }
  
}
.footer3_header{
    width: 100%;
    font-size: 24px;
    text-align: left;
    /* background-color:hotpink; */
    display: block;
}
.footer3>div>.img1{
    margin-right: 20px;
    margin-top: 6px;
    width: 15px;
    height: 20px;
}
.footer3>div>.img2{
    margin-right: 20px;
    width: 15px;
    height: 20px;
}
.footer3>div>.img3{
    margin-right: 20px;
    width: 15px;
    height: 20px;
}
.footer3>div>span{
    width: 90%;
}
.footer3>div>span div:nth-child(1){
    display: inline-block;
}
.footer3>div>span div:last-child{
    margin-left: 3.4rem;
}
.footer3>div{
    display: flex;
    width: 100%;
    text-align: left;
    /* background-color: green; */
    margin-top: 15px;
}
.footer2_ul > li > span {
  color: gray;
}
.footer2_ul > li > span>a{
  color: gray;
}
.footer2_ul li {
  list-style: none;
  text-align:left;
}
.footer2_ul li img{
  width: 5%;
  margin-right: 5%;
}
.footer2_txt_ul {
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  margin: 0 auto;
}
.footer2_txt {
  font-size: 24px;
  display: block;
  margin: 0 auto;
  margin-left: -57px;
}
.footer1_btn {
  background-color: #009944;
}
.footer1_txt1 {
  display: block;
  margin-top: 30px;
  margin-bottom: 30px;
}
.footer1-1 {
  float: left;
  display: flex;
}
.footer {
  height: 600px;
  margin: 0 auto;
  background: url("../../img/footer_bj.png");
  text-align: center;
  background-size: cover;
}
.footer_txt {
  width: 80%;
  padding-top: 200px;
  margin: 0 auto;
}
.footer1 {
  text-align: left;
  display: flex;
  align-items: center;
  flex-wrap: inherit;
}
.footer-logo{
    display: block;
    margin: 0 auto;
    width: 100px;
}
@media screen and (max-width: 992px) {
  .footer{
    height: 450px;
  }
  .footer1{
    text-align: center;
  }
  .footer1>img{
    width: 50% !important;
  }
  .footer1-1{
    margin: 0 auto;
    float:none;
  }
  .footer3 {
    display: none;
  }
  .footer2{
    display: none;
  }
}
@media screen and (max-width: 768px){
    .footer{
        height: 300px;
    }
    .footer_txt{
        width: 100%;
        padding: 90px 15px 0 15px;
    }
}
@media screen and (max-width: 576px){
  .footer1{
    text-align: center;
    width: 100%;
  }
}
</style>
<script>
export default {
  data() {
    return {
      input: "",
      sceah:[]
    };
  },
  mounted(){
    this.axios.get('/api/product/search?proName=ND&language=2&page=1&perNum=10').then((res)=>{
      this.sceah=res.data.proList
      console.log(this.sceah)
    })
  },
  methods:{
    // sosuo(){
    //   if(this.input==""){
    //     alert('请输入想要搜索的内容！')
    //   }else{
    //     let inp=this.input;
    //     let list=this.sceah;
    //     let idid=
    //     this.$router.push({path:'/product_item',query:{id:inp}})
    //   }
    // }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/zzj/footer.vue